<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2" title="成果信息">
			<a-descriptions-item label="成果名称">{{ form.name }}</a-descriptions-item>
			<a-descriptions-item label="所属高新技术领域">
				<dict-render :dict-obj="dictObjs['belong_techField']" :text="form.technoSphere"
					v-if="form.technoSphere"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="合作方式">
				<dict-render :dict-obj="dictObjs['cooperation_methods']" :text="form.cooperationWay"
					v-if="form.cooperationWay"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="交易价格(万元)">{{ form.transactionValue }}</a-descriptions-item>
			<a-descriptions-item label="应用行业">
				<dict-render :dict-obj="dictObjs['research_field']" :text="form.applicationIndustry"
					v-if="form.applicationIndustry"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="产业类型">
				<dict-render :dict-obj="dictObjs['industry_type']" :text="form.industryType"
					v-if="form.industryType"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="关键字(多个逗号隔开)">{{ form.keyWord }}</a-descriptions-item>
			<a-descriptions-item label="技术成熟度">
				<dict-render :dict-obj="dictObjs['technical_maturity']" :text="form.techMaturity"
					v-if="form.techMaturity"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="专利状况已授权(授权数)">{{ form.authorizedCount }}</a-descriptions-item>
			<a-descriptions-item label="已投入经费（万元）">{{ form.expensesIncurred }}</a-descriptions-item>
			<a-descriptions-item label="预期再投入经费（万元）">{{ form.expectedReinvestment }}</a-descriptions-item>
			<a-descriptions-item label="成果类型">
				<dict-render :dict-obj="dictObjs['result_type']" :text="form.achievementClassify"
					v-if="form.achievementClassify"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="成果立项时间">{{ form.started && form.started.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="成果发布时间">{{ form.ended && form.ended.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="成果图片" :span="2">
				<img-upload v-model:value="form.achievementPicture" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
			<a-descriptions-item label="成果摘要" :span="2">{{ form.achievementAbstract }}</a-descriptions-item>
			<a-descriptions-item label="成果简介" :span="2">{{ form.achievementSynopsis }}</a-descriptions-item>
		</a-descriptions>
		<a-descriptions :column="2" title="负责人信息">
			<a-descriptions-item label="负责人头像">
				<img-upload v-model:value="form.headPortrait" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
			<a-descriptions-item label="姓名">{{ form.principal }}</a-descriptions-item>
			<a-descriptions-item label="性别">{{ form.sex && form.sex == '0' ? '男' : '女' }}</a-descriptions-item>
			<a-descriptions-item label="手机号">{{ form.principalPhone }}</a-descriptions-item>
			<a-descriptions-item label="出生日期">{{ form.birthDate && form.birthDate.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="学历">
				<dict-render :dict-obj="dictObjs['education_background']" :text="form.education"
					v-if="form.education"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="从事专业">
				<dict-render :dict-obj="dictObjs['education_major']" :text="form.major" v-if="form.major"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="职务">{{ form.duty }}</a-descriptions-item>
			<a-descriptions-item label="职称">{{ form.rank }}</a-descriptions-item>
			<a-descriptions-item label="研究领域">
				<dict-render :dict-obj="dictObjs['research_field']" :text="form.researchField"
					v-if="form.researchField"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="学科">
				<dict-render :dict-obj="dictObjs['achievements_subject']" :text="form.subject" v-if="form.subject"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="团队信息">{{ form.teamInformation }}</a-descriptions-item>
			<a-descriptions-item label="论文">{{ form.paper }}</a-descriptions-item>
			<a-descriptions-item label="邮箱">{{ form.email }}</a-descriptions-item>
			<a-descriptions-item label="所属团体名称" :span="2">{{ form.belongTeam }}</a-descriptions-item>
			<a-descriptions-item label="个人简介" :span="2">{{ form.individualResume }}</a-descriptions-item>
			<a-descriptions-item label="参与项目" :span="2">{{ form.participationProject }}</a-descriptions-item>
			<a-descriptions-item label="参与荣誉" :span="2">{{ form.achievementHonor }}</a-descriptions-item>
		</a-descriptions>
		<a-descriptions :column="2" title="评价信息">
			<a-descriptions-item label="关联专家">{{ form.expertName || '暂无' }}</a-descriptions-item>
			<a-descriptions-item label="评估状态">{{ form.assessStatus && form.assessStatus == 1 ? '通过' : form.assessStatus &&
				form.assessStatus == 2 ? '不通过' : '暂无'
			}}</a-descriptions-item>
			<a-descriptions-item label="报告结论" :span="2">{{ form.evaluate || '暂无' }}</a-descriptions-item>
			<a-descriptions-item label="证书" :span="2">
				<file-upload v-model:value="form.report" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
		</a-descriptions>
		<!-- <div class="pingguInfo">对接列表</div>
		<a-table :columns="columns" :data-source="form.connectArr" bordered :pagination="false"></a-table> -->
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";
const columns = [
	{ title: "姓名", dataIndex: "senderContact", key: "senderContact" },
	{ title: "联系电话", dataIndex: "senderContactNumber", key: "senderContactNumber" },
];
export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			columns,
			dictNames: "belong_techField,cooperation_methods,education_background,research_field,industry_type,technical_maturity,education_major,achievements_subject,result_type",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.pingguInfo {
	-webkit-box-flex: 1;
	-ms-flex: auto;
	flex: auto;
	overflow: hidden;
	color: rgba(0, 0, 0, 0.85);
	font-weight: bold;
	font-size: 16px;
	line-height: 1.5715;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 15px;
}
</style>
